import { render } from "./BitacoraList.vue?vue&type=template&id=35a49029"
import script from "./BitacoraList.vue?vue&type=script&lang=js"
export * from "./BitacoraList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__